import { useState } from "react";
import { useQuery } from "react-query";
import axios from "../../config/axiosInstance";
import { FILIAL } from "../../config/apiConfig";
import { useApplication } from "../../contexts/ApplicationContext";
import { getActiveCompanyId } from "../../utils/jwt";
import { alertDialog } from "../../utils/dialogs";
import {
  companyDisplayName,
  describeSwitchCompanyError,
  sortCompaniesAlphabetically,
  switchActiveCompany,
} from "../../utils/companies";

// Saída de emergência do bloqueio de plano. O modal de plano não fecha e cobre o
// menu lateral (onde fica o seletor de empresa); como o plano é por empresa, quem
// cai numa filial com plano vencido ficava preso nela. Este botão fica acima do
// modal e só aparece quando há outra empresa para onde ir.
const BlockedCompanySwitch = () => {
  const { user } = useApplication();
  const [open, setOpen] = useState(false);
  const [switching, setSwitching] = useState(null);

  // Mesma chave e mesma consulta do seletor do menu lateral (cache compartilhado).
  const { data: companies = [] } = useQuery(
    ["my-companies", user?.id],
    async () => {
      const { data } = await axios.get(FILIAL.MY_COMPANIES);
      return data;
    },
    { enabled: !!user?.id, staleTime: 30_000 },
  );

  const activeId = Number(getActiveCompanyId(user));
  const others = sortCompaniesAlphabetically(companies).filter(
    (company) => Number(company.id) !== activeId,
  );
  if (!others.length) return null;

  const handleSwitch = async (targetId) => {
    if (switching) return;
    try {
      setSwitching(targetId);
      await switchActiveCompany(targetId);
    } catch (error) {
      setSwitching(null);
      alertDialog({
        title: "Não foi possível trocar de empresa",
        message: describeSwitchCompanyError(error),
        tone: "error",
      });
    }
  };

  return (
    <div className="fixed bottom-4 left-4 z-[1200]">
      {open && (
        <div className="mb-2 w-64 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl">
          <p className="px-3 pt-2.5 pb-1 text-[10px] font-semibold uppercase tracking-widest text-slate-400">
            Trocar empresa
          </p>
          {others.map((company) => (
            <button
              key={company.id}
              type="button"
              disabled={!!switching}
              onClick={() => handleSwitch(company.id)}
              className="w-full px-3 py-2.5 text-left text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-60"
            >
              {companyDisplayName(company)}
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="rounded-lg bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-lg ring-1 ring-slate-200 hover:bg-slate-50"
      >
        Trocar de empresa
      </button>
    </div>
  );
};

export default BlockedCompanySwitch;
